'use strict';

angular.module('adelementAdminApp')
	.controller('ProspectiveUsersDeleteController', function($scope, $uibModalInstance, entity, ProspectiveUsers) {

        $scope.prospectiveUsers = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            ProspectiveUsers.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });
